import VehicleVisualsBoxHtml from './templates/vehicle-visuals.box.html';

export function VehicleVisualsCatalog () {
  return {
    controller: 'VehicleVisualsCatalogCtrl',
    restrict: 'E',
    scope: {
      company: '=',
      customer: '=',
      documentType: '=',
      inspection: '=',
      invoice: '='
    },
    templateUrl: VehicleVisualsBoxHtml
  }
}